import script from "./history-attribute.vue?vue&type=script&setup=true&lang=ts"
export * from "./history-attribute.vue?vue&type=script&setup=true&lang=ts"

import "./history-attribute.vue?vue&type=style&index=0&id=35dea480&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35dea480"]])

export default __exports__